import { PurposeTemplate } from '../../../../pure-js/types/PurposeTemplate'
import { useCurrentUser } from './queries'

export function useUserPurposeTemplates(): PurposeTemplate[] {
  const { data: userResponse } = useCurrentUser()
  return userResponse?.data?.purposeTemplates ?? []
}
